export default __webpack_public_path__ + "static/SFMono-Medium-315f324cb40775f82e34eae859bd2618.woff";